<script>
    import {onMount} from "svelte";
    import {getObjects, saveObj} from '../lib/data.js';
    import Loader from '../Utilities/Loader.svelte';

    import { notifier } from '@beyonk/svelte-notifications'
    import {querystring} from 'svelte-spa-router'

    $: getAssessments = getObjects("assessmentType");
</script>

{#await getAssessments}
    <Loader />
{:then assessments}
    <div class="title">Assessment Types</div>

    <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Assessment Types</th>
                <th style="width: 350px">Actions</th>
            </tr>
        </thead>
        <tbody>
            {#each assessments as assessment}
            <tr>
                <td>{assessment.name}</td>
                <td>
                    <a href="#/assessmentType/{assessment.id}" class="button">Edit</a>
                    <a href="#/assessmentType/view/{assessment.id}" class="button">Template</a>
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
    <a href="#/assessmentType/" class="button is-primary is-pulled-right">New Assessment Type</a>
{/await}